import React from 'react';

import WidgetInput from './WidgetInput';
import PropsCheckbox from './interfaces/PropsCheckboxInterface';

export default class WidgetCheckbox extends WidgetInput<PropsCheckbox> {
    constructor(props: PropsCheckbox) {
        super(props);
    }

    onChange(event: React.ChangeEvent<HTMLInputElement>) {
        this.props.handleChange(this.props.name, event.target.checked ? event.target.value : null);
    }

    render() {
        return React.createElement('input', {
            id: this.props.id,
            name: this.props.name,
            onChange: this.onChange,
            type: this.props.type,
            disabled: this.props.disabled,
            checked: this.getRenderValue() === 'on',
        });
    }
}
